import React from 'react';
import PropTypes from 'prop-types';
import {FaCalendarAlt, FaDownload, FaListUl, FaPlayCircle, FaTv, FaUsers} from 'react-icons/fa';
import {useTranslation} from 'react-i18next';

const actionIcon = icon => ({
  calendar: FaCalendarAlt,
  playlist: FaListUl,
  report: FaDownload,
  tv: FaTv,
  users: FaUsers,
  video: FaPlayCircle
}[icon] || FaPlayCircle);

const RepPartnerQuickActions = ({workspace, onOpenAction}) => {
  const {t} = useTranslation();

  return (
    <div className="rep-assistant-skywork__examples is-partner" role="group" aria-label={t('REP_PARTNER_QUICK_ACTIONS')} data-partner-mode={workspace.mode}>
      {workspace.actions.map(action => {
        const Icon = actionIcon(action.icon);
        return <button type="button" key={action.id} onClick={() => onOpenAction(action)}><Icon aria-hidden="true"/> {t(action.labelKey)}</button>;
      })}
    </div>
  );
};

RepPartnerQuickActions.propTypes = {
  workspace: PropTypes.shape({
    mode: PropTypes.string.isRequired,
    introKey: PropTypes.string,
    placeholderKey: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      labelKey: PropTypes.string.isRequired
    })).isRequired
  }).isRequired,
  onOpenAction: PropTypes.func.isRequired
};

export default RepPartnerQuickActions;
